import { Directive } from '@angular/core';

import { BaseContainer } from '@stylehaven/components';
import { Task, TaskContainerData } from '../../entities/task.entity';

@Directive()
export class TaskContainer extends BaseContainer {
    constructor(public taskData: TaskContainerData) {
        super();
    }

    get task(): Task {
        return this.taskData.task$.value;
    }
}
